import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip } from 'bootstrap';
import { STEP_SUCCESS } from '../constants/wizard';

export default function Breadcrumb({ step, setStep }) {
	const { t } = useTranslation();
	useEffect(() => {
		const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
		tooltipTriggerList.forEach((el) => new Tooltip(el));
	}, [step]);

	if (step === STEP_SUCCESS) {
		return null;
	}

	return (
		<div className="breadcrumb d-flex justify-content-between align-items-center mb-4 mt-4">
			{[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14].map((stepNumber, index) => {
				const isCompleted = stepNumber < step;
				const isActive = stepNumber === step;
				const label = t(`app.breadcrumb.${stepNumber}`);

				return (
					<div key={stepNumber} className="breadcrumb-step text-center" style={{ flex: 1, position: 'relative' }}>
						<div
							className={`circle ${isCompleted ? 'completed' : isActive ? 'active' : 'upcoming'}`}
							onClick={() => stepNumber < step && setStep(stepNumber)}
							style={{ cursor: stepNumber < step ? 'pointer' : 'default' }}
							title={label}
							data-bs-toggle="tooltip"
						>
							{stepNumber}
						</div>
						{index !== 13 && (
							<div className={`line ${stepNumber < step ? 'completed' : 'upcoming'}`} />
						)}
					</div>
				);
			})}
		</div>
	);
}
